/**
 * Shared promotions query key
 * This allows different components to access the same promotions data
 */
export const PROMOTIONS_QUERY_KEY = ['shared-promotions'];

/**
 * Horizontal Banner resolutions for mobile and desktop
 */
export const banner_resolution = {
    mobile: 'horizontal_phone_en',
    desktop: 'horizontal_web_en',
};

/**
 * Defining class name for pagination element
 */
export const paginationElementClassName = 'paging';

/**
 * Pattern mappings for vertical carousel image types.
 *
 * @const
 * @type {Readonly<{
 *   titleLogo: string;
 *   portrait: string;
 *   landscape: string;
 * }>}
 *
 * @property {string} titleLogo - Pattern identifier for title logo images (e.g., 'tvapps_title_en')
 * @property {string} portrait - Pattern identifier for portrait orientation images (e.g., 'alt_home_vertical')
 * @property {string} landscape - Pattern identifier for landscape orientation images (e.g., 'alt_home_horizontal')
 *
 * @example
 * // Access title logo pattern
 * const titlePattern = VERTICAL_CAROUSEL_IMAGE_TYPE_PATTERNS.titleLogo; // 'tvapps_title_en'
 */
export const VERTICAL_CAROUSEL_IMAGE_TYPE_PATTERNS = {
    titleLogo: 'tvapps_title_en',
    portrait: 'alt_home_vertical',
    landscape: 'alt_home_horizontal',
} as const;
